module.exports = "build/assets/PensumPro-BoldItalic.5fda8829.woff";